<template>
    <div class="conversation">
        <div class="conversation-container">
            <div class="message received">
                <div class="pl-2 pt-2">
                    <strong v-if="parsedComponents.header?.text" style="font-size: 18px;">{{ parsedComponents.header.text }}</strong>
                    <div v-if="parsedComponents.body?.text" style="font-size: 15px; margin-top: 10px; margin-bottom: 10px;" v-html="textFormatted"></div>
                </div>
                
                <div class="message-footer">
                    <div v-if="parsedComponents.footer?.text" class="text-muted pl-2" style="font-size: 14px;">
                        {{ parsedComponents.footer.text }}
                    </div>
                    <span class="metadata">
                        <span class="time">
                            {{ obtenerHora12h }}
                        </span>
                    </span>
                </div>

                <template v-if="parsedComponents.buttons?.length">
                    <hr class="text-muted" style="margin-top: 5px !important;">
                    <div v-for="(button, index) in parsedComponents.buttons" :key="index" class="text-center">
                        <img src="https://static.xx.fbcdn.net/rsrc.php/v4/y0/r/OzOCQC-ukqH.png" class="image-button" aria-hidden="true">
                        <a :href="button.url" target="_blank" style="color: #33B7F6;">{{ button.text }}</a>
                        <hr v-if="index !== parsedComponents.buttons.length - 1" class="text-muted">
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        components: {
            type: [String, Object],
            required: true
        }
    },
    data() {
        return {
            parsedComponents: {
                header: { text: "" },
                body: { text: "" },
                footer: { text: "" },
                buttons: []
            }
        };
    },
    methods: {
        parseComponents(components) {
            try {
                if (typeof components !== 'string') return components;

                const parsedComponents = JSON.parse(components);

                const formattedComponents = {
                    header: { text: "" },
                    body: { text: "" },
                    footer: { text: "" },
                    buttons: []
                };

                parsedComponents.forEach(component => {
                    switch (component.type) {
                    case 'HEADER':
                        formattedComponents.header.text = component.text || "";
                        break;
                    case 'BODY':
                        formattedComponents.body.text = component.text || "";
                        break;
                    case 'FOOTER':
                        formattedComponents.footer.text = component.text || "";
                        break;
                    case 'BUTTONS':
                        formattedComponents.buttons = component.buttons || [];
                        break;
                    }
                });

                return formattedComponents;
            } catch (error) {
                console.error("Error al parsear components:", error);
                return {
                    header: { text: "" },
                    body: { text: "" },
                    footer: { text: "" },
                    buttons: []
                };
            }
        }
    },
    computed: {
        textFormatted() {
            let text = this.parsedComponents.body?.text;

            text = text.replace(/\n/g, '<br>');
            text = text.replace(/```([\s\S]+?)```/g, '<code>$1</code>');
            text = text.replace(/\*([^*]+)\*/g, '<strong>$1</strong>');
            text = text.replace(/_([^_]+)_/g, '<em>$1</em>');
            text = text.replace(/~([^~]+)~/g, '<s>$1</s>');

            return text;
        },
        obtenerHora12h() {
            const fecha = new Date();
            let horas = fecha.getHours();
            const minutos = fecha.getMinutes();
            
            horas = horas % 12 || 12;
            const minutosFormateados = minutos.toString().padStart(2, '0');

            return `${horas}:${minutosFormateados}`;
        }
    },
    mounted() {
        this.parsedComponents = this.parseComponents(this.components);
    }
};
</script>

<style scoped>
@media (max-width: 768px) {
    .conversation {
        width: 305px !important;
    }
    .message.received {
        width: 215px !important;
    }
}
.conversation {
    min-height: 220px;
    width: 450px;
    position: relative;
    background: #efe7dd url("https://cloud.githubusercontent.com/assets/398893/15136779/4e765036-1639-11e6-9201-67e728e86f39.jpg") repeat;
    z-index: 0;
    padding: 15px;
}

.conversation ::-webkit-scrollbar {
    transition: all .5s;
    width: 5px;
    height: 1px;
    z-index: 10;
}
.conversation ::-webkit-scrollbar-track {
    background: transparent;
}
.conversation ::-webkit-scrollbar-thumb {
    background: #b3ada7;
}
.conversation .conversation-container {
    padding: 0 16px;
    margin-bottom: 5px;
    text-align: left;
}
.conversation .conversation-container:after {
    content: "";
    display: table;
    clear: both;
}
.message {
    color: #000;
    line-height: 18px;
    font-size: 15px;
    position: relative;
    margin-top: 20px;
    padding-bottom: 15px;
    width: 300px;
    z-index: -1;
    min-height: 205px;
    display: flex;
    flex-direction: column;
}
.message hr {
    width: 100%;
    border: none;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    margin: 14px 0;
    display: block;
}
.message-footer {
    display: flex;
    justify-content: space-between;
    padding-right: 8px;
}
.message:after {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    border-style: solid;
}
.metadata {
    font-size: 11px;
    color: rgba(0, 0, 0, .45);
}
.metadata .time {
    color: rgba(0, 0, 0, .45);
    font-size: 11px;
    display: inline-block;
    padding-top: 1px;
}
.message.received {
    background: #fff;
    border-radius: 0px 10px 10px 10px;
    float: left;
    min-height: 20%;
}
.message.received .metadata {
    padding: 0 0 0 16px;
}
.message.received:after {
    border-width: 0px 10px 10px 0;
    border-color: transparent #fff transparent transparent;
    top: 0;
    left: -10px;
}
.image-button {
    background-repeat: no-repeat;
    background-size: contain;
    flex-shrink: 0;
    height: 16px;
    width: 16px;
    opacity: .8;
}
</style>